import React, { useRef } from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'
import ClientSlider from './ClientSlider';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Slide } from 'react-awesome-reveal';

let clients = [
    {
        name : "Aman Rawat",
        position : "web developer , DIT",
        img_url : "https://media.licdn.com/dms/image/D4D03AQG0cE69XAWczw/profile-displayphoto-shrink_200_200/0/1685852279437?e=1694649600&v=beta&t=EgX0AGzshaAu3PNBZbwtNWvy0e2jgRY0c0tnsDFNNwg",
        stars : 3,
        disc : `I wanted to take a moment to express my utmost satisfaction and appreciation for our recent collaboration on the web development project. Working together on this endeavor has been a truly rewarding experience, and I am delighted with the remarkable results we have achieved. `
    },
    {
        name : "Deepesh Kalura",
        position : "flutter developer,GEU",
        img_url : "https://media.licdn.com/dms/image/D4D03AQH-YUqpeo-XpA/profile-displayphoto-shrink_200_200/0/1670953518980?e=1694649600&v=beta&t=M6TNavEP8m-Vxsusm8O-UX_i9Cv5neKxtIhsZhfRPgA",
        stars : 4,
        disc : `From the outset, your expertise and commitment to delivering excellence were evident. Your team's technical prowess and attention to detail were instrumental in creating a website that exceeded my expectations. The level of professionalism and dedication demonstrated throughout the development process was truly commendable.`
    },
    {
        name : "Harshit Rawat",
        position : "data scientist , GIT",
        img_url : "https://pps.whatsapp.net/v/t61.24694-24/358457522_1195039704516920_7085967143018670529_n.jpg?ccb=11-4&oh=01_AdQ-Oirv53mX8WYdhO0nsqezPRzUOMOKV9EtMTXnqvJorg&oe=64BDDB34",
        stars : 5,
        disc : `I was particularly impressed with the way you translated our vision into reality. The website's design reflects our brand identity perfectly, and the user interface is intuitive and engaging. The seamless navigation and visually appealing elements have undoubtedly enhanced the overall user experience.`
    },
    {
        name : "Lovish Semalti",
        position : "web developer , HIT",
        img_url : "",
        stars : 5,
        disc : `I would like to extend my sincere gratitude to you and your team for the outstanding effort and commitment invested in this project. It has been a pleasure working with you, and I look forward to exploring future opportunities for collaboration.`
    },
]
var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows : false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]}

const Clients = () => {
    const arrowRef = useRef(null);
    let clientDisc = "";
    clientDisc = clients.map((item, i) => (
        <ClientSlider item={item} key={i}/>
    ))
  return (
    <Container id='client'>
        <Slide direction="left">
            <span className="green">testimonials</span>
            <h1>what clients say</h1>
        </Slide>
        <Testimonials>
            <Slider ref={arrowRef} {...settings}>
                {clientDisc}
            </Slider>
            <Buttons>
                <button
                onClick={() => arrowRef.current.slickPrev()}
                ><IoIosArrowBack/></button>
                <button
                onClick={() => arrowRef.current.slickNext()}
                ><IoIosArrowForward/></button>
            </Buttons>
        </Testimonials>
    </Container>
  )
}

export default Clients

const Container = styled.div`
    width: 80%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 4rem 0;

    @media(max-width:840px){
        width: 90%;
    }

    span{
        font-weight: 700;
        text-transform: uppercase;
    }

    h1{
        padding-top: 1rem;
        text-transform: capitalize;
    }

    .slick-list, .slick-slider, .slick-track{
        padding: 0;
    }

    .slick-dots{
        text-align: left;
        margin-left: 1rem;
    }

    .slick-dots li button:before{
        content: "";
    }

    .slick-dots li button{
        width: 9px;
        height: 4px;
        background: linear-gradient(159deg, rgb(45, 45, 58) 0%, rgb(43, 43, 53) 100%);
        padding: 0.1rem;
        margin-top: 1rem;
        transition: all 400ms ease-in-out;
        border-radius: 50px;
    }
    
    .slick-dots li.slick-active button{
        background: #01be96;
        width: 15px;
    }

    .slick-dots li{
        margin: 0;
    }
`

const Testimonials = styled.div`
    margin-top: 2rem;
    position: relative;
`
const Buttons = styled.div`
    position: absolute;
    right: 0.7rem;
    bottom: -2rem;

    button{
        background-color: transparent;
        margin-left: 0.5rem;
        border: none;
        color: #01be96;
        cursor: pointer;
        font-size: 1.1rem;
    }

    @media(max-width:530px){
        display: none;
    }
`